export default "__VITE_ASSET__DX6H7MA$__"